module.exports = __webpack_public_path__ + "static/media/duck.713c3819.jpg";